import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './admin.css';

const AdminGuard = ({ children }) => {
    const navigate = useNavigate();
    const hasToken = !!localStorage.getItem('token');

    useEffect(() => {
        if (!hasToken) navigate('/admin/login', { replace: true });
    }, [hasToken, navigate]);

    if (!hasToken) return null;
    return <div className="admin-scope">{children}</div>;
};

export default AdminGuard;
